module.exports = __webpack_public_path__ + "static/media/warning.ec1ecb92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/warning.svg
// module id = 48
// module chunks = 0